export default "__VITE_ASSET__D8iC8L3O__"